<div class="container-fluid">
  <h4>{{'Maintenance.header' | translate}}</h4>
  <div class="row">
    <div class="col-8">
      <h5>{{'Maintenance.lblReIndexDb' | translate}}</h5>
      <p>{{'Maintenance.lblParaReIndexDb' | translate}}</p>
      @if (maintenance.reIndexParagraph !== '') {
        <p [@slider]="maintenance.reIndexParagraph !== ''? 'show' : null" class="slider"><i>{{maintenance.reIndexParagraph}}</i></p>
      }
    </div>
    <div class="col-4">
      <div class="row">
        <mat-form-field class="col-9" style="padding-right: 0px;">
          <div class=" dateTimeInput">
            <input matInput [(ngModel)]="reIndexDatetimePicker.datetime" [ngModelOptions]="{standalone: true}" readonly>
            <span>
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <ngx-material-timepicker-toggle matSuffix [for]="tp1"></ngx-material-timepicker-toggle>
            </span>
            <mat-datepicker #dp1 disabled="false"></mat-datepicker>
            <ngx-material-timepicker [appendToInput]="true" #tp1></ngx-material-timepicker>
          </div>
        </mat-form-field>
        <div class="col-3" style="padding-left: 0px; margin: auto;">
          @if (service.currentUser.isReadOnly === false) {
            <button mat-stroked-button color="primary" type="button" (click)="OnClickApply('reindex')">{{'btnApply' | translate}}</button>
          }
        </div>
      </div>
      <div style="margin-top: -30px;">
        <input [ngxTimepicker]="tp1" [(ngModel)]="reIndexDatetimePicker.time" [ngModelOptions]="{standalone: true}" style="visibility: hidden; width: 0px; height: 0px;" (ngModelChange)="OnChangedDatetime(reIndexDatetimePicker)" />
        <input [matDatepicker]="dp1" [(ngModel)]="reIndexDatetimePicker.date" [ngModelOptions]="{standalone: true}" style="visibility: hidden; width: 0px; height: 0px;" (ngModelChange)="OnChangedDatetime(reIndexDatetimePicker)" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <h5>{{'Maintenance.lblRestartAgent' | translate}}</h5>
      <p>{{'Maintenance.lblParaRestartAgent' | translate}}</p>
      @if (maintenance.restartAgentParagraph !== '') {
        <p [@slider]="maintenance.restartAgentParagraph !== ''? 'show' : null" class="slider"><i>{{maintenance.restartAgentParagraph}}</i></p>
      }
    </div>
    <div class="col-4">
      <div class="row">
        <mat-form-field class="col-9" style="padding-right: 0px;">
          <div class=" dateTimeInput">
            <input matInput [(ngModel)]="restartAgentDatetimePicker.datetime" [ngModelOptions]="{standalone: true}" readonly>
            <span>
              <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
              <ngx-material-timepicker-toggle matSuffix [for]="tp2"></ngx-material-timepicker-toggle>
            </span>
            <mat-datepicker #dp2 disabled="false"></mat-datepicker>
            <ngx-material-timepicker [appendToInput]="true" #tp2></ngx-material-timepicker>
          </div>
        </mat-form-field>
        <div class="col-3" style="padding-left: 0px; margin: auto;">
          <span>
            @if (service.currentUser.isReadOnly === false) {
              <button mat-stroked-button color="primary" type="button" (click)="OnClickApply('restart')">{{'btnApply' | translate}}</button>
            }
          </span>
        </div>
      </div>
      <div style="margin-top: -30px;">
        <input [ngxTimepicker]="tp2" [(ngModel)]="restartAgentDatetimePicker.time" [ngModelOptions]="{standalone: true}" style="visibility: hidden; width: 0px; height: 0px;" (ngModelChange)="OnChangedDatetime(restartAgentDatetimePicker)" />
        <input [matDatepicker]="dp2" [(ngModel)]="restartAgentDatetimePicker.date" [ngModelOptions]="{standalone: true}" style="visibility: hidden; width: 0px; height: 0px;" (ngModelChange)="OnChangedDatetime(restartAgentDatetimePicker)" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h5>{{'Maintenance.lblManageVendors' | translate}}</h5>
    </div>
  </div>
  <div class="mat-elevation-z8 mt-3">
    <div class="scrollableTable">
      <table mat-table [dataSource]="vendorlist" matSort matSortActive="vendor" matSortDirection="asc">

        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 75%;"> {{'Maintenance.thVendor' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; text-align: center;"> {{'Maintenance.thActive' | translate}}</th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"><mat-checkbox [(ngModel)]="element.enabled" [ngModelOptions]="{standalone: true}" color="primary" [class.mat-checkbox-disabled]="false" disabled></mat-checkbox></td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; text-align: center;">{{'thActions' | translate}}</th>
          <td mat-cell *matCellDef="let element" style="text-align: center;">
            @if (service.currentUser.isReadOnly === false) {
              <button mat-icon-button color="primary" (click)="OnEditVendor(element)">
                <mat-icon>edit</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="loading">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
        </ng-container>

        <ng-container matColumnDef="noData">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Maintenance.tblNoData' | translate}}... </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':vendorlist!=null}"></tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
        [ngClass]="{'hide':(vendorlist!=null && vendorsLength != 0) || isLoading === true}"></tr>

      </table>
    </div>
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]" [length]="vendorsLength"></mat-paginator>
  </div>

  @if (service.currentUser.isReadOnly === false) {
    <div class="mt-3">
      <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnSaveVendors()">{{'btnSave' | translate}}</button>
    </div>
  }
</div>
